export class PedidoIntegracaoImportFilter {
    idIntegracao: number;
    idLocalFaturamento: number;
    codigoIntegracaoLocalFaturamento: string;
    numero: number;
    idPedidoIntegracao: number;
    numeroPedidoIntegracao: string;
    dataEmissaoInicial: Date;
    dataEmissaoFinal: Date;
}
